import { ymd, fmt, itemsForDay, todayStr } from "@/lib/dates";
import { ShiftChip, TaskChip, HolidayChip } from "@/components/calendar/Chips";

const MonthCell = ({ day, data, inMonth, team, names, onSelect, onOpenDay, onAdd }) => {
  const { shifts, tasks, holidays } = itemsForDay(data, day, team ? null : data.users[0]?.id);
  const othersOff = team ? [] : data.holidays.filter((h) => h.user_id !== data.users[0]?.id && h.start_date <= day && h.end_date >= day);
  const items = [
    ...holidays.map((h) => <HolidayChip key={h.id} holiday={h} showName={team} onClick={() => onSelect({ kind: "holiday", item: h })} />),
    ...othersOff.map((h) => <HolidayChip key={h.id} holiday={h} onClick={() => onSelect({ kind: "holiday", item: h })} />),
    ...(team ? [] : shifts.map((s) => <ShiftChip key={s.id} shift={s} compact onClick={() => onSelect({ kind: "shift", item: s })} />)),
    ...tasks.map((t) => <TaskChip key={t.id} task={t} compact onClick={() => onSelect({ kind: "task", item: t })} />),
  ];
  return (
    <div className={`min-h-[64px] md:min-h-[120px] p-1 md:p-1.5 border-b border-r border-slate-100 cursor-copy hover:bg-slate-50 transition-colors ${inMonth ? "bg-white" : "bg-slate-50/60"}`} onClick={(e) => { if (window.innerWidth < 768) return onOpenDay(day); if (e.target === e.currentTarget || e.target.dataset.cellfill) onAdd(day); }} data-testid={`month-cell-${day}`}>
      <button onClick={() => onOpenDay(day)} className={`text-sm font-bold w-7 h-7 rounded-full grid place-items-center mb-1 hover:bg-[#EAF2F2] ${day === todayStr() ? "bg-[#24474A] text-white" : inMonth ? "text-slate-700" : "text-slate-400"}`} data-testid={`month-day-btn-${day}`}>
        {fmt(day, "d")}
      </button>
      {team && shifts.length > 0 && (
        <div className="hidden md:block text-[11px] font-bold text-teal-800 bg-teal-50 border border-teal-200 rounded-md px-1.5 py-0.5 mb-1" title={shifts.map((s) => names[s.user_id]).join(", ")}>
          {shifts.length} on shift
        </div>
      )}
      <div className="md:hidden flex flex-wrap gap-1 px-0.5 pointer-events-none" data-testid={`month-dots-${day}`}>
        {shifts.length > 0 && <span className="w-2 h-2 rounded-full bg-teal-600" />}
        {tasks.length > 0 && <span className="w-2 h-2 rounded-full bg-amber-500" />}
        {holidays.length + othersOff.length > 0 && <span className="w-2 h-2 rounded-full bg-rose-400" />}
      </div>
      <div className="hidden md:block space-y-1 min-h-[40px]" data-cellfill="1">
        {items.slice(0, 3)}
        {items.length > 3 && <button onClick={() => onOpenDay(day)} className="text-[11px] text-slate-500 px-1 hover:text-[#24474A]">+{items.length - 3} more</button>}
      </div>
    </div>
  );
};

export const MonthView = ({ days, data, monthIndex, team, onSelect, onOpenDay, onAdd }) => {
  const names = Object.fromEntries(data.users.map((u) => [u.id, u.name]));
  return (
    <div className="overflow-x-auto rounded-2xl border border-slate-200 bg-white" data-testid="month-calendar">
      <div className="grid grid-cols-7 md:min-w-[760px] border-l border-t border-slate-100">
        {["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"].map((d) => (
          <div key={d} className="px-1 md:px-2 py-2 text-[10px] md:text-[11px] uppercase tracking-[0.1em] md:tracking-[0.15em] text-slate-500 bg-slate-50/70 border-b border-r border-slate-100">{d}</div>
        ))}
        {days.map((d) => (
          <MonthCell key={ymd(d)} day={ymd(d)} data={data} inMonth={d.getMonth() === monthIndex} team={team} names={names} onSelect={onSelect} onOpenDay={onOpenDay} onAdd={onAdd} />
        ))}
      </div>
    </div>
  );
};
